import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import { FaPhone, FaEnvelope, FaTelegram, FaMapMarkerAlt, FaLeaf } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <div className={styles.footerLogo}>
            <FaLeaf />
            <h3>GreenLeaf</h3>
          </div>
          <p className={styles.footerDescription}>
            Ваш надежный партнер в мире натуральной косметики и экологически чистых продуктов.
          </p>
        </div>

        <div className={styles.footerSection}>
          <h4>Навигация</h4>
          <ul className={styles.footerLinks}>
            <li>
              <Link to="/">Главная</Link>
            </li>
            <li>
              <Link to="/catalog/facial-skin-care">Каталог</Link>
            </li>
            <li>
              <Link to="/about-us">О нас</Link>
            </li>
            <li>
              <Link to="/become-a-partners">Стать партнером</Link>
            </li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h4>Контакты</h4>
          <ul className={styles.footerContacts}>
            <li>
              <FaPhone />
              <a href="tel:+79133731366">+7 (913) 373-13-66</a>
            </li>
            <li>
              <FaEnvelope />
              <a href="mailto:swetbog72@gmail.com">swetbog72@gmail.com</a>
            </li>
            <li>
              <FaMapMarkerAlt />
              <span>Россия, Новосибирск</span>
            </li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h4>Социальные сети</h4>
          <div className={styles.socialLinks}>
            <a
              href="https://t.me/bogswet"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Telegram"
            >
              <FaTelegram />
            </a>
            <a
              href="https://max.ru/u/f9LHodD0cOIdOGkS4p4ftvX_YNO5bFmqBrFXxf1rbuIimZb7BldA2oS2UQY"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Max"
            >
              <svg
                width="22px"
                version="1.1"
                id="Слой_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 322 319.7284851"
                enable-background="new 0 0 1000 319.7284851"
                xmlSpace="preserve"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  fill="rgba(255, 255, 255, 0.8)"
                  d="M164.0085602,318.8161011
                  c-31.5135651,0-46.1585617-4.6004944-71.614769-23.002594c-16.1018295,20.7023315-67.0909348,36.8808594-69.3145142,9.2010498
                  c0-20.7790222-4.6005192-38.337677-9.8144436-57.5065155C7.054132,223.8920135,0,197.5923615,0,159.484726
                  C0,68.4710846,74.6817856,0,163.1651459,0c88.5600128,0,157.9512177,71.8448029,157.9512177,160.3281403
                  C321.4136047,247.443161,251.1228333,318.3513794,164.0085602,318.8161011z M165.3120422,78.6689148
                  c-43.0915375-2.2235794-76.6753464,27.6031265-84.112854,74.3750916
                  c-6.1340332,38.7210541,4.7538681,85.8764038,14.0315857,88.3300018
                  c4.4471664,1.0734558,15.6417694-7.9742432,22.6192245-14.9516907
                  c11.5375748,7.9704437,24.9729691,12.7574768,38.9510727,13.8782349
                  c44.6499329,2.1477356,82.80159-31.8444214,85.7997131-76.4453125c1.7453156-44.6953049-32.6325836-82.551918-77.2887573-85.109642
                  L165.3120422,78.6689148z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} GreenLeaf. Все права защищены.</p>
        <p className={styles.footerNote}>
          ООО "Зеленый лист" - официальный представитель GreenLeaf в России
        </p>
      </div>
    </footer>
  );
};

export default Footer;
